require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-basic-css-use-rgb-values-to-color-elements.json") })
        }
      }, "path---responsive-web-design-basic-css-use-rgb-values-to-color-elements");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-basic-css-use-rgb-values-to-color-elements!./.cache/json/responsive-web-design-basic-css-use-rgb-values-to-color-elements.json
// module id = 2630
// module chunks = 231608221292675